import {
  updatePlugin,
  enablePlugin,
  disablePlugin,
} from '@wix/wix-code-collections-api'
import type { PublishingStatus } from '@wix/wix-data-schema-types'

import { PUBLISHING_PLUGIN_ID } from '@wix/wix-data-client-common-standalone'

export const getPublishingPluginPatches = (
  publishingMode?: PublishingStatus,
  initialPublishingMode?: PublishingStatus,
) => {
  if (publishingMode === initialPublishingMode) {
    return []
  }

  if (publishingMode && initialPublishingMode) {
    return [
      updatePlugin(PUBLISHING_PLUGIN_ID, { defaultStatus: publishingMode }),
    ]
  }

  if (publishingMode && !initialPublishingMode) {
    return [
      enablePlugin(PUBLISHING_PLUGIN_ID, { defaultStatus: publishingMode }),
    ]
  }

  if (!publishingMode && initialPublishingMode) {
    return [disablePlugin(PUBLISHING_PLUGIN_ID)]
  }

  return []
}
